module.exports = __webpack_public_path__ + "static/media/36.614658a6.png";